module.exports = __webpack_public_path__ + "static/img/tabs04.2c079318.png";